import { matchPath, Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { TransitionGroup } from "react-transition-group";
import CheckShift from "../components/CheckShift/CheckShift";
import HeaderNavContainer from "../components/HeaderNavContainer/HeaderNavContainer";
import { useAuth } from "../contexts/auth";
import CadastroAccessGroups from "../views/AccessGroups/CadastroAccessGroups/CadastroAccessGroups";
import ConsultaAccessGroups from "../views/AccessGroups/ConsultaAccessGroups/ConsultaAccessGroups";
import CadastroAccessPoints from "../views/AccessPoints/CadastroAccessPoints/CadastroAccessPoints";
import ConsultaAccessPoints from "../views/AccessPoints/ConsultaAccessPoints/ConsultaAccessPoints";
import CadastroAutomationButtons from "../views/AutomationButtons/CadastroAutomationButtons/CadastroAutomationButtons";
import ConsultaAutomationButtons from "../views/AutomationButtons/ConsultaAutomationButtons/ConsultaAutomationButtons";
import ConsultaBackup from "../views/Backup/ConsultaBackup/ConsultaBackup";
import CadastroClientes from "../views/Clientes/CadastroClientes/CadastroClientes";
import ConsultaClientes from "../views/Clientes/ConsultaClientes/ConsultaClientes";
import CadastroCondominios from "../views/Condominios/CadastroCondominios/CadastroCondominios";
import ConsultaCondominios from "../views/Condominios/ConsultaCondominios/ConsultaCondominios";
import CadastroCondoUsers from "../views/CondoUsers/CadastroCondoUsers/CadastroCondoUsers";
import ConsultaCondoUsers from "../views/CondoUsers/ConsultaCondoUsers/ConsultaCondoUsers";
import CadastroInvitation from "../views/Invitations/CadastroInvitation/CadastroInvitation";
import ConsultaInvitations from "../views/Invitations/ConsultaInvitations/ConsultaInvitations";
import EditProfile from "../views/EditProfile/EditProfile";
import Events from "../views/Events/ConsultaEvents/Events";
import CadastroLicencasCliente from "../views/Licencas/CadastroLicencasCliente/CadastroLicencasCliente";
import ConsultaLicencasCliente from "../views/Licencas/ConsultaLicencasCliente/ConsultaLicencasCliente";
import ConsultaLicencasECondominios from "../views/Licencas/ConsultaLicencasECondominios/ConsultaLicencasECondominios";
import Login from "../views/Login/Login";
import Logs from "../views/Logs/Logs";
import CadastroOperadores from "../views/Operadores/CadastroOperadores/CadastroOperadores";
import ConsultaOperadores from "../views/Operadores/ConsultaOperadores/ConsultaOperadores";
import Reception from "../views/Reception/Reception";
import ConsultaTurnos from "../views/Turnos/ConsultaTurnos/ConsultaTurnos";
import CadastroBatchUnits from "../views/Units/CadastroBatchUnits/CadastroBatchUnits";
import CadastroUnits from "../views/Units/CadastroUnits/CadastroUnits";
import ConsultaUnits from "../views/Units/ConsultaUnits/ConsultaUnits";
import CadastroUsers from "../views/Users/CadastroUsers/CadastroUsers";
import ConsultaUsers from "../views/Users/ConsultaUsers/ConsultaUsers";
import ConsultaPoliticas from "../views/AccessManagementCloud/Policies/ConsultaPoliticas/ConsultaPoliticas";
import CadastroPoliticas from "../views/AccessManagementCloud/Policies/CadastroPoliticas/CadastroPoliticas";
import SelectOrganization from "../views/SelectOrganization/SelectOrganization";
import CadastroTurnos from "../views/Turnos/CadastroTurnos/CadastroTurnos";
import ConsultaRoles from "../views/AccessManagementCloud/Roles/ConsultaRoles/ConsultaRoles";
import CadastroRoles from "../views/AccessManagementCloud/Roles/CadastroRoles/CadastroRoles";
import ConsultaGroups from "../views/AccessManagementCloud/Groups/ConsultaGroups/ConsultaGroups";
import CadastroGroups from "../views/AccessManagementCloud/Groups/CadastroGroups/CadastroGroups";
import DefineNewPassword from "../views/DefineNewPassword/DefineNewPassword";
import { Footer } from "../components/Footer/Footer";
import { NotAllowed } from "../views/NotAllowed/NotAllowed";
import { WaitBackup } from "../views/WaitBackup/WaitBackup";
import { useBackup } from "../contexts/backup";
import { NotFound } from "../views/NotFound/NotFound";
import { useUserStore } from "../contexts/userStore";
import { BlockedFeature } from "../views/BlockedFeature/BlockedFeature";
import { BackupImportation } from "../components/BackupImportation/BackupImportation";
import Monitoring from "../views/Monitoring/Monitoring";
import { CriticalAlarms } from "../components/CriticalAlarms/CriticalAlarms";
import ConsultaWebhooks from "../views/Webhooks/ConsultaWebhooks/ConsultaWebhooks";
import CadastroWebhooks from "../views/Webhooks/CadastroWebhooks/CadastroWebhooks";
import { NotifierConfigurations } from "../views/NotifierConfigurations/NotifierConfigurations";
import CadastroTags from "../views/Tags/CadastroTags/CadastroTags";
import ConsultaTags from "../views/Tags/ConsultaTags/ConsultaTags";
import './routes.css';
import { ConsultaReaders } from "../views/Readers/ConsultaReaders/ConsultaReaders";
import { CadastroReaders } from "../views/Readers/CadastroReaders/CadastroReaders";
import { GeneralSettingsReaders } from "../views/Readers/GeneralSettingsReaders/GeneralSettingsReaders";
import ConsultaInterlocks from "../views/Interlocks/ConsultaInterlocks/ConsultaInterlocks";
import CadastroInterlocks from "../views/Interlocks/CadastroInterlocks/CadastroInterlocks";
import ConsultaAntiPassbacks from "../views/AntiPassbacks/ConsultaAntiPassbacks/ConsultaAntiPassbacks";
import CadastroAntiPassbacks from "../views/AntiPassbacks/CadastroAntiPassbacks/CadastroAntiPassbacks";
import { Sandbox } from "../views/Sandbox/Sandbox";
import { Reports } from "../views/Reports/Reports";
import { Configurations } from "../views/Configurations/Configurations";
import { MyGeolocation } from "../components/MyGeolocation/MyGeolocation";
import { ConsultaAccessRoutes } from "../views/AccessRoutes/ConsultaAccessRoutes/ConsultaAccessRoutes";
import { CadastroAccessRoutes } from "../views/AccessRoutes/CadastroAccessRoutes/CadastroAccessRoutes";
import ConsultaLicencasClienteNew from "../views/Licencas/ConsultaLicencasClienteNew/ConsultaLicencasClienteNew";
import { LicensesOverview } from "../views/Licenses/LicensesOverview/LicensesOverview";
import { DiscountReasons } from "../views/Licenses/DiscountReasons/DiscountReasons";
import { LicenseFeatures } from "../views/Licenses/LicenseFeatures/LicenseFeatures";
import { LicenseTypes } from "../views/Licenses/LicenseTypes/LicenseTypes";
import { LicenseStock } from "../views/Licenses/LicensesStock/LicensesStock";
import { LicenseBlocked } from "../views/Licenses/LicenseBlocked/LicenseBlocked";
import { LicenseAttention } from "../views/Licenses/LicenseAttention/LicenseAttention";
import { NewDiscountReason } from "../views/Licenses/DiscountReasons/NewDiscountReason";
import { EditDiscountReason } from "../views/Licenses/DiscountReasons/EditDiscountReason";
import { useEffect } from "react";
import { NewLicenseType } from "../views/Licenses/LicenseTypes/NewLicenseType";
import { EditLicenseType } from "../views/Licenses/LicenseTypes/EditLicenseType";
import { NewLicenseFeature } from "../views/Licenses/LicenseFeatures/NewLicenseFeature";
import { EditLicenseFeature } from "../views/Licenses/LicenseFeatures/EditLicenseFeature";
import Licenses from "../views/Licenses/Licenses/Licenses";
import { NewLicense } from "../views/Licenses/Licenses/NewLicense";
import { EditLicense } from "../views/Licenses/Licenses/EditLicense";

export const routes = [
	// geral
	{ action: "", path: "/edit-profile", element: <EditProfile /> },
	{ path: '/not-found', element: <NotFound /> },
	{ path: '/not-allowed', element: <NotAllowed /> },
	{ path: '/blocked-feature', element: <BlockedFeature /> },
	{ path: '/wait-backup', element: <WaitBackup /> },
	{ path: '/', element: <></> },
	{ path: '/sandbox', element: <Sandbox /> },
	{ path: '/mygeolocation', element: <MyGeolocation /> },

	// root
	{ selectedOrganization: false, action: "bravas.identity.organization.create", path: "/cadastro-clientes", element: <CadastroClientes /> },
	{ selectedOrganization: false, action: "bravas.identity.organization.getPaginated", path: "/consulta-clientes", element: <ConsultaClientes /> },

	{ action: "bravas.accessControl.license.detailed.getPaginated", path: "/consulta-licencas", element: <ConsultaLicencasCliente /> },
	{ action: "bravas.accessControl.license.analytics", path: "/licenses-overview", element: <LicensesOverview /> },
	{ action: "bravas.accessControl.license.detailed.getPaginated", path: "/licenses", element: <Licenses /> },
	{ action: "bravas.accessControl.license.create", path: "/licenses/new", element: <NewLicense /> },
	{ action: "bravas.accessControl.license.detailed.getPaginated", path: "/licenses/stock", element: <LicenseStock /> },
	{ action: "bravas.accessControl.license.detailed.getPaginated", path: "/licenses/blocked", element: <LicenseBlocked /> },
	{ action: "bravas.accessControl.license.detailed.getPaginated", path: "/licenses/attention", element: <LicenseAttention /> },

	{ action: "bravas.accessControl.license.type.getPaginated", path: "/licenses/types", element: <LicenseTypes /> },
	{ action: "bravas.accessControl.license.type.create", path: "/licenses/types/new", element: <NewLicenseType /> },
	{ action: "bravas.accessControl.license.type.update", path: "/licenses/types/:licenseTypeId", element: <EditLicenseType /> },

	{ action: "bravas.accessControl.license.feature.getPaginated", path: "/licenses/features", element: <LicenseFeatures /> },
	{ action: "bravas.accessControl.license.feature.create", path: "/licenses/features/new", element: <NewLicenseFeature /> },
	{ action: "bravas.accessControl.license.feature.update", path: "/licenses/features/:licenseFeatureId", element: <EditLicenseFeature /> },

	{ action: "bravas.accessControl.license.discountReason.getPaginated", path: "/licenses/discount-reasons", element: <DiscountReasons /> },
	{ action: "bravas.accessControl.license.discountReason.create", path: "/licenses/discount-reasons/new", element: <NewDiscountReason /> },
	{ action: "bravas.accessControl.license.discountReason.update", path: "/licenses/discount-reasons/:discountReasonId", element: <EditDiscountReason /> },

	{ selectedOrganization: false, action: "bravas.accessControl.license.create", path: "/cadastro-licencas", element: <CadastroLicencasCliente /> },
	{ selectedOrganization: false, action: "bravas.apiGateway.log.getPaginated", path: "/logs", element: <Logs /> },
	{ action: "bravas.accessManagement.user.getPaginated", path: "/consulta-users", element: <ConsultaUsers /> },
	{ action: "bravas.accessManagement.user.create", path: "/cadastro-users", element: <CadastroUsers /> },
	{ action: "bravas.accessManagement.user.create", path: "/users/:userId", element: <CadastroUsers /> },
	// { action: "", path: "/login", element: <Navigate to="/consulta-licencas" /> },

	// admin
	{ selectedUnit: true, action: "bravas.accessControl.license.getPaginated", path: "/licencas", element: <ConsultaLicencasECondominios /> },
	{ action: "bravas.identity.tag.create", path: "/cadastro-tags", element: <CadastroTags /> },
	{ action: "bravas.identity.tag.create", path: "/tags/:tagId", element: <CadastroTags /> },
	{ action: "bravas.identity.tag.getPaginated", path: "/consulta-tags", element: <ConsultaTags /> },
	{ action: "bravas.identity.unit.create", path: "/cadastro-condominios", element: <CadastroCondominios /> },
	{ action: "bravas.identity.unit.create", path: "/condominios/:condominioId", element: <CadastroCondominios /> },
	{ action: "bravas.identity.unit.getPaginated", path: "/consulta-condominios", element: <ConsultaCondominios /> },
	{ action: "bravas.identity.person.create", path: "/cadastro-operadores", element: <CadastroOperadores /> },
	{ action: "bravas.identity.person.create", path: "/perfil/:roleId/cadastro-operadores", element: <CadastroOperadores /> },
	{ action: "bravas.identity.person.getPaginated", path: "/consulta-operadores", element: <ConsultaOperadores /> },
	{ action: "bravas.identity.person.getPaginated", path: "/pessoa/:personId", element: <CadastroOperadores /> },
	{ action: "bravas.identity.shift.getPaginated", path: "/consulta-turnos", element: <ConsultaTurnos /> },
	{ action: "bravas.identity.shift.create", path: "/cadastro-turnos", element: <CadastroTurnos /> },
	{ action: "bravas.identity.shift.create", path: "/turnos/:shiftId", element: <CadastroTurnos /> },
	{ action: "bravas.accessManagement.policy.getPaginated", path: "/consulta-politicas-de-acesso", element: <ConsultaPoliticas /> },
	{ action: "bravas.accessManagement.policy.create", path: "/cadastro-politicas", element: <CadastroPoliticas /> },
	{ action: "bravas.accessManagement.policy.create", path: "/politicas/:policyId", element: <CadastroPoliticas /> },
	{ action: "bravas.accessManagement.role.getPaginated", path: "/consulta-papeis", element: <ConsultaRoles /> },
	{ action: "bravas.accessManagement.role.create", path: "/cadastro-papeis", element: <CadastroRoles /> },
	{ action: "bravas.accessManagement.role.create", path: "/papeis/:roleId", element: <CadastroRoles /> },
	{ action: "bravas.accessManagement.group.getPaginated", path: "/consulta-grupos", element: <ConsultaGroups /> },
	{ action: "bravas.accessManagement.group.create", path: "/cadastro-grupos", element: <CadastroGroups /> },
	{ action: "bravas.accessManagement.group.create", path: "/grupos/:groupId", element: <CadastroGroups /> },
	{ action: "bravas.identity.organization.partialUpdate", rootUnitAccess: true, path: "/configuracoes/:tab", element: <Configurations /> },
	{ action: "bravas.identity.organization.partialUpdate", rootUnitAccess: true, path: "/configuracoes/:tab/:page", element: <Configurations /> },
	{ action: "bravas.identity.organization.partialUpdate", rootUnitAccess: true, path: "/configuracoes/:tab/:page/:id", element: <Configurations /> },

	{ action: "bravas.notifier.webhook.getPaginated", path: "/consulta-webhooks", element: <ConsultaWebhooks /> },
	{ action: "bravas.notifier.webhook.create", path: "/cadastro-webhooks", element: <CadastroWebhooks /> },
	{ action: "bravas.notifier.webhook.update", path: "/webhooks/:webhookId", element: <CadastroWebhooks /> },
	{ action: "bravas.notifier.configuration.save", path: "/configuracoes-notificador", element: <NotifierConfigurations /> },

	// { action: "", path: "/login", element: <Navigate to="/consulta-condominios" /> },
	// operator
	{ selectedUnit: true, action: "bravas.accessControl.general.reception", path: "/monitoramento/:tab", element: <Reception /> },

	{ selectedUnit: true, action: "bravas.events.device.getByModulePaginated", path: "/historico-eventos", element: <Events /> },
	{ selectedUnit: true, action: "bravas.accessControl.accessModule.getPaginated", path: "/consulta-access-points", element: <ConsultaAccessPoints /> },
	{ selectedUnit: true, action: "bravas.accessControl.accessModule.create", path: "/cadastro-access-points", element: <CadastroAccessPoints /> },
	{ selectedUnit: true, action: "bravas.accessControl.accessModule.create", path: "/access-points/:accessPointId", element: <CadastroAccessPoints /> },
	{ selectedUnit: true, action: "bravas.accessControl.reader.getPaginated", path: "/consulta-readers", element: <ConsultaReaders /> },
	{ selectedUnit: true, action: "bravas.accessControl.reader.getServices", path: "/configuracoes-gerais-leitoras", element: <GeneralSettingsReaders /> },
	{ selectedUnit: true, action: "bravas.accessControl.reader.getServices", path: "/configuracoes-gerais-leitoras/:readerModel", element: <GeneralSettingsReaders /> },
	{ selectedUnit: true, action: "bravas.accessControl.reader.create", path: "/cadastro-readers/:readerModel", element: <CadastroReaders /> },
	{ selectedUnit: true, action: "bravas.accessControl.reader.create", path: "/readers/:readerId", element: <CadastroReaders /> },
	{ selectedUnit: true, action: "bravas.accessControl.group.getPaginated", path: "/consulta-access-groups", element: <ConsultaAccessGroups /> },
	{ selectedUnit: true, action: "bravas.accessControl.group.create", path: "/cadastro-access-groups", element: <CadastroAccessGroups /> },
	{ selectedUnit: true, action: "bravas.accessControl.group.create", path: "/access-groups/:accessGroupId", element: <CadastroAccessGroups /> },

	{ selectedUnit: true, action: "bravas.accessControl.interlock.getPaginated", path: "/consulta-interlocks", element: <ConsultaInterlocks /> },
	{ selectedUnit: true, action: "bravas.accessControl.interlock.create", path: "/cadastro-interlocks", element: <CadastroInterlocks /> },
	{ selectedUnit: true, action: "bravas.accessControl.interlock.create", path: "/interlocks/:interlockId", element: <CadastroInterlocks /> },

	{ selectedUnit: true, action: "bravas.accessControl.antiPassback.getPaginated", path: "/consulta-anti-passbacks", element: <ConsultaAntiPassbacks /> },
	{ selectedUnit: true, action: "bravas.accessControl.antiPassback.create", path: "/cadastro-anti-passbacks", element: <CadastroAntiPassbacks /> },
	{ selectedUnit: true, action: "bravas.accessControl.antiPassback.create", path: "/anti-passbacks/:antiPassbackId", element: <CadastroAntiPassbacks /> },

	{ selectedUnit: true, action: "bravas.accessControl.user.getPaginated", path: "/consulta-condo-users", element: <ConsultaCondoUsers /> },
	{ selectedUnit: true, action: "bravas.accessControl.user.create", path: "/cadastro-condo-users", element: <CadastroCondoUsers /> },
	{ selectedUnit: true, action: "bravas.accessControl.user.create", path: "/device-users/:condoUserId", element: <CadastroCondoUsers /> },

	{ selectedUnit: true, action: "bravas.accessControl.user.getPaginated", path: "/consulta-invitations", element: <ConsultaInvitations /> },
	{ selectedUnit: true, action: "bravas.accessControl.user.create", path: "/cadastro-invitations", element: <CadastroInvitation /> },
	{ selectedUnit: true, action: "bravas.accessControl.user.create", path: "/invitations/:invitationId", element: <CadastroInvitation /> },

	{ selectedUnit: true, action: "bravas.accessControl.group.getPaginated", path: "/consulta-access-routes", element: <ConsultaAccessRoutes /> },
	{ selectedUnit: true, action: "bravas.accessControl.group.create", path: "/cadastro-access-routes", element: <CadastroAccessRoutes /> },
	{ selectedUnit: true, action: "bravas.accessControl.group.create", path: "/access-routes/:accessRouteId", element: <CadastroAccessRoutes /> },

	{ action: "", path: "/monitoramento", element: <Monitoring /> },

	{ action: "", path: "/relatorios/:reportType", element: <Reports /> },

	{ selectedUnit: true, enabledBackup: true, action: "bravas.backup.management.list", path: "/consulta-backups", element: <ConsultaBackup /> },
	{ selectedUnit: true, action: "bravas.accessControl.automationButton.create", path: "/cadastro-automation-buttons", element: <CadastroAutomationButtons /> },
	{ selectedUnit: true, action: "bravas.accessControl.automationButton.create", path: "/automation-buttons/:automationButtonId", element: <CadastroAutomationButtons /> },
	{ selectedUnit: true, action: "bravas.accessControl.automationButton.getPaginated", path: "/consulta-automation-buttons", element: <ConsultaAutomationButtons /> },
	{ selectedUnit: true, action: "bravas.identity.unit.create", path: "/cadastro-units/:tagExternalId", element: <CadastroUnits /> },
	{ selectedUnit: true, action: "bravas.identity.unit.create", path: "/units/:tagExternalId/:unitId", element: <CadastroUnits /> },
	{ selectedUnit: true, action: "bravas.identity.unit.batchCreate", path: "/cadastro-batch-units/:tagExternalId", element: <CadastroBatchUnits /> },
	{ selectedUnit: true, action: "bravas.identity.unit.getPaginated", path: "/consulta-units/:tagExternalId", element: <ConsultaUnits /> },
	{ action: "", path: "/selecione-organizacao", hideMenu: true, element: <SelectOrganization /> },
	// { action: "", path: "/login", element: <Navigate to="/portaria" /> },
];

export default function AppRoutes() {
	const location = useLocation();
	const { user, isLogged, can } = useAuth();
	const { selectedLicenceObj } = useUserStore();
	const { backup, isImporting } = useBackup();

	useEffect(() => console.log('requested path: ', location.pathname), [location.pathname]);

	const currentRoute = routes.find((route) => {
		if (!route.path) return false;
		return matchPath(route.path, location.pathname);
	});

	let isRouteAllowed = false;

	if (user && currentRoute) {
		isRouteAllowed = user.userData.isSuperAdmin || !currentRoute.action || can?.(currentRoute.action);
	}

	if (location.pathname.startsWith('/redefinir-senha')) {
		return (
			<Routes>
				<Route path="/redefinir-senha/:userId/:token" element={<DefineNewPassword />} />
			</Routes>
		);
	}

	if (!isLogged?.()) {
		return (
			<Routes>
				<Route path="/login" element={<Login />} />
				<Route path="*" element={<Navigate to={'/login'} state={{ ref: location.pathname }} />} />
			</Routes>
		);
	}

	function renderRoutes() {
		const allowedRoutes = routes
			.filter((route) => !route.action || can?.(route.action));

		console.log('current route: ', currentRoute);

		if (!currentRoute) {
			return <Route path="*" element={<Navigate to={'/not-found'} state={{ ref: location.pathname }} />} />;
		}
		if (!isRouteAllowed) {
			return <Route path="*" element={<Navigate to={'/not-allowed'} state={{ ref: location.pathname }} />} />;
		}
		if (currentRoute.enabledBackup !== undefined && currentRoute.enabledBackup !== selectedLicenceObj?.enabledBackup) {
			return <Route path="*" element={<Navigate to={'/blocked-feature'} state={{ ref: location.pathname, feature: 'backups' }} />} />;
		}
		if (location.pathname !== '/consulta-backups' && currentRoute.selectedUnit === true && isImporting && backup && (backup.currentStage < backup.totalImportingStages)) {
			return <Route path="*" element={<Navigate to={'/wait-backup'} state={{ ref: location.pathname }} />} />;
		}
		return allowedRoutes.map(({ path, element }, index) => (
			<Route
				key={index}
				path={path}
				element={<CheckShift>{element}</CheckShift>}
			/>
		));
	}

	return (
		<div style={{ display: 'flex', width: '100vw', height: '100vh' }}>
			{user && (!currentRoute || (currentRoute && !currentRoute.hideMenu)) && <HeaderNavContainer />}
			<div style={{ flex: '1', height: '100vh', overflowY: 'auto', padding: '14px', scrollbarGutter: 'stable' }} className={`${currentRoute?.hideMenu ? 'select-organization' : ''}`}>
				<TransitionGroup component={null}>
					<Routes location={location}>
						{renderRoutes()}
					</Routes>
				</TransitionGroup>
				<Footer showSignOut={currentRoute?.hideMenu} />
			</div>
			{user && <BackupImportation />}
			{selectedLicenceObj && (<CriticalAlarms />)}
		</div>
	);
}
